module.exports = __webpack_public_path__ + "static/media/Pizza-Easy.5c4c5064.jpeg";